import { debug } from 'zf-web-infra';
import { Dropdown, Space, Button } from 'antd';
import { convert, Icons } from 'zf-web-components/icons';
import { isActionMenuItem } from '../types';
import type { ReactElement, ReactNode } from 'react';
import type { ColumnProps } from 'antd/es/table';
import type { ActionProps } from '../types';

export function Action<T>(props: ActionProps<T>): ReactElement | null {
  debug.common('Action', props);
  return null;
}

Action.displayName = 'Action';

/**
 * 通过 Space 包裹 Dropdown 和 align 属性，将操作按钮默认右对齐
 * TODO: child.props应该删除无关的属性
 * TODO: 菜单项的图标缺少样式
 * @param child
 * @returns
 */
export function getActionProps<T>(child: ReactElement<ColumnProps<T>>): ColumnProps<T> {
  debug.common('getActionProps');

  const {
    menu,
    onClick,
    label,
    align = 'right',
    fixed = 'left',
    labelIcon = null
  } = child.props as ActionProps<T>;

  if (menu == null) {
    return getButtonAction(child);
  }

  return {
    render: (val: unknown, record: T): ReactNode => {
      // 将字符串转换为图标
      const items = menu.items.map(item => {
        if (isActionMenuItem(item)) {
          return {
            ...item,
            icon: convert(item.icon),
            onClick: () => item.onClick?.(record)
          };
        }
        return item;
      });

      return (
        <Space>
          <Dropdown.Button
            icon={<Icons name='DownOutlined' />}
            menu={{ ...menu, items }}
            onClick={() => onClick(record)}
          >
            {labelIcon}{label}
          </Dropdown.Button>
        </Space>
      );
    },
    align,
    fixed,
    ...child.props
  };
}

/**
 * 仅有一个按钮的操作列
 * @param child
 * @returns
 */
function getButtonAction<T>(child: ReactElement<ColumnProps<T>>): ColumnProps<T> {
  debug.common('getButtonAction');

  const {
    onClick,
    label,
    align = 'right',
    labelIcon
  } = child.props as ActionProps<T>;

  return {
    render: (val: unknown, record: T): ReactNode => (
      <Button type = 'default' icon={labelIcon} onClick={() => onClick(record)}>
        {label}
      </Button>
    ),
    align,
    ...child.props
  };
}
